module.exports.JOBS_TO_RESTRICT = [
  'Étudiant',
  'Élève-avocat',
  'Stagiaire',
  'Particulier',
  'Membre d’une association',
  'Doctorant',
  'Autre',
  'Association',
];
